import React, { useEffect } from 'react';

import { PopupPreview } from '@confluence/template-preview/entry-points/PopupPreview.ts';
import { LoadingTemplateCard } from '@confluence/template-card/entry-points/LoadingTemplateCard.ts';
import { PageSegmentLoadMark } from '@confluence/browser-metrics/entry-points/PageSegmentLoadMark.ts';
import { IN_EDITOR_TEMPLATES_METRIC } from '@confluence/template-utils/entry-points/IN_EDITOR_TEMPLATES_METRIC.ts';

type LoadingTemplateListProps = {
	length?: number;
};

export const LoadingTemplateListCards = ({ length = 3 }: LoadingTemplateListProps) => {
	useEffect(() => {
		void PopupPreview.preload();
	}, []);

	return (
		<div data-testid="template-list-cards-loading">
			{Array(length)
				.fill(null)
				.map((_, index) => (
					<LoadingTemplateCard key={index} />
				))}
			<PageSegmentLoadMark markName="fmp" metric={IN_EDITOR_TEMPLATES_METRIC} />
		</div>
	);
};
